// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import UserCircle20 from './UserCircle20';
import UserCircle24 from './UserCircle24';

type UserCircleProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    UserCircle20,
    UserCircle24,
};

const UserCircle: FC<UserCircleProps> = ({ variation, ...props }) => {
    const variationKey = `UserCircle${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"UserCircle" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default UserCircle;
